// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._7dBPcWJnx{display:inline-flex;align-items:stretch}._2a1ifLwNx{border-top-right-radius:0;border-bottom-right-radius:0}._7bRwr93Bx{border-top-left-radius:0;border-bottom-left-radius:0;min-width:0;border-left:1px solid rgba(0,0,0,0.08);padding-left:6px;padding-right:6px}._7bRwr93Bx._6uRlZZiHx{padding-left:2px;padding-right:2px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_7dBPcWJnx",
	"primary-action": "_2a1ifLwNx",
	"primaryAction": "_2a1ifLwNx",
	"secondary-action": "_7bRwr93Bx",
	"secondaryAction": "_7bRwr93Bx",
	"xsmall": "_6uRlZZiHx"
};
module.exports = exports;
